import { createAction, props } from '@ngrx/store';
import { FetchArgs, PagingToken } from 'src/app/shared/models/core';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { ShippingRequestGridItem } from 'src/app/compliance/shipping-requests/shipping-request-grid-item';

export const reassignBulkTickets = createAction(
    '[SHIPPING REQUESTS COMPONENT] Reassign Bulk Tickets',
    props<{ assigneeId: number; ticketIds: number[] }>()
);
export const reassignBulkTicketsSuccess = createAction(
    '[SHIPPING REQUESTS COMPONENT] Reassign Bulk Tickets Success',
    props<{ success: boolean }>()
);
export const reassignBulkTicketsFailure = createAction(
    '[SHIPPING REQUESTS COMPONENT] Reassign Bulk Tickets Failure',
    props<{ error: any }>()
);

export const getListOfAssignees = createAction('[SHIPPING REQUESTS COMPONENT] Get List Of Assignees');
export const getListOfAssigneesSuccess = createAction(
    '[SHIPPING REQUESTS COMPONENT] Get List Of Assignees Success',
    props<{ assignees: Lookup[] }>()
);
export const getListOfAssigneesFailure = createAction(
    '[SHIPPING REQUESTS COMPONENT] Get List Of Assignees Failure',
    props<{ error: any }>()
);
export const setShippingRequestsFilter = createAction(
    '[SHIPPING REQUESTS COMPONENT] Set Shipping Requests filter',
    props<{ filter: FetchArgs }>()
);
export const getListOfShippingRequestsSuccess = createAction(
    '[SHIPPING REQUESTS API] Get List Of Shipping Requests Success',
    props<{ shippingRequests: PagingToken<ShippingRequestGridItem[]> }>()
);
export const getListOfShippingRequestsFailure = createAction(
    '[SHIPPING REQUESTS API] Get List Of Shipping Requests Failure',
    props<{ error: unknown }>()
);
